/** API route segments used to build request URLs via ApiRequest. Use these with API_AUTH_TYPES. */
export const API_ROUTES = {
  ADMIN: "admin",
  ADMIN_AUDIT: "admin-audit",
  DEV_TEAM: "dev-team",
  AUTH: "auth",
  ADVICE_LIBRARY: "advice_library",
  ADVICE_LIBRARY_PROGRESS: "advice_library_progress",
  HOUSEHOLD_ADVICE_LIBRARY_PREFERENCES: "household_advice_library_preferences",
  CUSTOM_SUB_AGENTS: 'custom_sub_agents',
  ADVISOR_DASHBOARD: "advisor_dashboard",
  ACTIVE_OUTREACH: "active-outreach",
  ADVISOR_RESOURCES: "advisor_resources",
  ANALYTICS: "analytics",
  ANALYTICS_VIEWS: "analytics_views",
  BEEHIIV: 'beehiiv',
  BLOG: "blog",
  BUDGET_CATEGORIES: "budget/categories",
  BUDGET_CATEGORY_GROUPS: "budget/category_groups",
  BUDGET_RULES: "budget/rules",
  BUDGET_CATEGORY_BUDGETS: 'budget/category_budgets',
  BUDGET_SPENDING_VIEWS: 'budget/spending_views',
  BUDGET_TRANSACTIONS: "budget/transactions",
  BUDGET_TRANSACTION_TAGS: "budget/transaction_tags",
  BUDGET_TRANSACTION_REVIEW_SETTINGS: "budget/transaction_review_settings",
  BUNMAIL: "bunmail",
  // CLIENT_EMAILS removed - endpoint was dead code
  CLIENT_DATA_PANEL: "client_data_panel",
  CLIENT_MEETINGS: "client_meetings",
  CLIENT_TASKS: "client_tasks",
  TASK_TAGS: "task_tags",
  CHAPTER_TEMPLATES: "chapter_templates",
  SPACES: "spaces",
  COMMUNICATION_OPPORTUNITIES: "communication_opportunities",
  CUSTOM_FORMS: "custom_forms",
  DOCUMENTATION: "documentation",
  DOCUMENTS: "documents",
  EMAIL_SERVICE: "email_service",
  FINANCIAL_ACCOUNTS: 'financial_accounts',
  FINANCIAL_STORY_CHAPTERS: "financial_story_chapters",
  FINANCIAL_STORY_TEMPLATES: "financial_story_templates",
  FIREBASE: "firebase",
  FEATURE_FLAGS: "feature-flags",
  FOLDERS: "folders",
  GROUPS: "groups",
  HOUSEHOLDS: "households",
  HOUSEHOLD_GOALS: "household_goals",
  HOUSEHOLD_NOTES: "household_notes",
  HOUSEHOLD_CONTACTS: 'household_contacts',
  HOUSEHOLD_LIFE_EVENTS: 'household_life_events',
  HOUSEHOLD_SEARCH: 'household_search',
  LEARNING_LAB: "learning_lab",
  MANAGER_DASHBOARD: "manager_dashboard",
  MEETING_NOTE_PROMPTS: "meeting_note_prompts",
  NOTIFICATIONS: "notifications",
  ONBOARDING: "onboarding",
  VOICE_TO_TEXT: "voice_to_text",
  ASSEMBLYAI: "assemblyai",
  QUILL_TEXT_EDITOR: "quill_text_editor",
  PARABOT: "parabot",
  PARABOT_ANALYTICS: "parabot_analytics",
  PARABOT_TRACES: "parabot-traces",
  PARABOT_FEEDBACK: "parabot-feedback",
  PLANNING: "planning",
  PORTFOLIOS: "portfolios",
  PROSPECTS: "prospects",
  PROSPECT_ASSIGNMENT: "prospect_assignment",
  REMINDERS: "reminders",
  RISK_TOLERANCE: "risk_tolerance",
  SECURITY: "security",
  SMART_TABLE: 'smart-table',
  SMART_TABLE_VIEWS: 'smart_table_views',
  SMART_TABLE_VIEW_GROUPS: 'smart_table_view_groups',
  SMART_TABLE_CUSTOM_COLUMNS: 'smart_table_custom_columns',
  HOUSEHOLD_SMART_TABLE_SETTINGS: 'household_smart_table_settings',
  DASHBOARD_CUSTOM_STATS: 'dashboard_custom_stats',
  DASHBOARD_TEMPLATES: 'dashboard_templates',
  STAT_CONFIGURATIONS: 'stat_configurations',
  STRIPE: "stripe",
  SUPPORT: "support",
  ERROR_LOGGING: "error-logging",
  USER_ACTIVITY: "user_activity",
  ADVISOR_NOTIFICATIONS: "advisor_notifications",
  USERS: "users",
  AGGREGATORS: 'aggregators',
  PLAID: 'plaid',
  PLAID_DEV_TOOLS: 'plaid-dev-tools',
  YOUVEST: 'youvest',
  AI_MAINTAINED_COLUMNS: 'ai_maintained_columns',
  AI_COLUMN_PROPOSALS: 'ai_column_proposals',
  AI_PROPOSALS_LOG: "ai-proposals-log",
  ERROR_LOGS_ADMIN: "error-logs-admin",
  ADVISOR_ACTIVITY_ADMIN: "advisor-activity-admin",
};

/**
 * Auth type suffixes appended to endpoint names (e.g. endpoint_auth_advisor).
 * Determines which authentication middleware runs on the server for the request.
 */
export const API_AUTH_TYPES = {
  USER: "user",
  CLIENT: "client",
  ADVISOR: "advisor",
  ADMIN: "admin",
  SUPER_ADMIN: 'super_admin',
  MANAGER: 'manager',
  LEARNING_LAB: "learning_lab",
  BLOG: "blog",
  ONBOARDING: "onboarding",
  NONE: 'none'
};
